import { TranslateService } from "projects/shared/src/lib/services/translate.service";
import { UserProjectsImageRendererComponent } from "./user-projects-image-renderer/user-projects-image-renderer.component";
import { UserProjectsButtonRendererComponent } from "./user-projects-button-renderer/user-projects-button-renderer.component";


export class AgGridUserProjectsSettings {

  constructor(private translate: TranslateService) { }

  //avatar: string = './assets/img/avatar-emty.png';

  public agGridUserProjectsSettings = {
    rowModelType: 'infinite', // virtual row model type
    //rowModelType: "'serverSide'",
    //pagination: true,
    //virtualPaging: true, // this is important, if not set, normal paging will be done
    //enableServerSideSorting: true,
    //enableServerSideFilter: true,
    rowSelection: 'single',
    //rowDeselection: true,
    rowHeight: 70,
    enableRangeSelection: true,
    cacheBlockSize: 10000, // This is how many rows each block in the cache should contain. Each call to your datasource will be for one block. 
    cacheOverflowSize: 2, // how many extra blank rows to display to the user at the end of the dataset, which sets the vertical scroll and then allows the grid to request viewing more rows of data. default is 1, ie show 1 row.
    maxConcurrentDatasourceRequests: 1, // how many server side requests to send at a time. if user is scrolling lots, then the requests are throttled down
    paginationPageSize: 30, // how big each page in our page cache will be, default is 100
    infiniteInitialRowCount: 0, // infiniteInitialRowCount: 2, how many rows to initially show in the grid. having 1 shows a blank row, so it looks like the grid is loading from the users perspective (as we have a spinner in the first col)
    //maxBlocksInCache: 10, // how many pages to store in cache. default is undefined, which allows an infinite sized cache, pages are never purged. this should be set for large data to stop your browser from getting full of data
    columnDefs: [
      // we want to sort by the row index, this make sense as the point of the row index is to know the row index in what came back from the server
      { field: 'display_Name',
      width: 100,
      headerName: `${this.translate.data["PROJECTSCOLUMNHEADER"]}`,
      sortable: true,
      filter: true,
      },
      {
        // headerName: "Image",
        // field: 'id',
        cellRenderer: UserProjectsImageRendererComponent,
        // cellRenderer: 'imageRenderer',
        // cellRendererParams: {
        //   icon_view: 'launch',
        //   icon_doc: 'folder',
        //   icon_topic: 'topic',
        // }
      },
      {
        width: 20,
        headerName: `${this.translate.data["PROJECTSACTIONSCOLUMNHEADER"]}`,
//        cellRenderer: 'buttonRenderer',
        cellRenderer: UserProjectsButtonRendererComponent,
        cellRendererParams: {
          icon_view: 'launch',
          icon_doc: 'folder',
          icon_topic: 'topic',
          // icon_clone:'file_copy',
          //icon_clone: 'control_point_duplicate',
          //routerLinkEditProject: (params: ICellRendererParams) => `/manage-projects/${_.get(params, 'data.id')}`
        }
      },

    ],
    defaultColDef: {
      flex: 1,
      //enableValue: true,
      ////sortable: false, 
      //enableRowGroup: true,
      resizable: true,
      //width: 50,
      minWidth: 100,
      //// filter: true,
      //enablePivot: true,
      editable: false,
      //alwaysShowVerticalScroll:true
    }
  }

}